import React from 'react';
import {
  Input,
  Tooltip,
} from '@mairistem/composants';
import type { Error } from '@mairistem/comptabilite';

interface TooltipInputProps {
  id: string;
  name: string;
  label: string;
  value: number | string;
  flowing: boolean;
  placeholder: string;
  description: string;
  error: Error;
  required: boolean;
  action: React.ReactNode;
  onChange: any;
  onBlur: any;
  position: string;
  maxLength?: number;
}

const TooltipInput = ({
  id,
  name,
  label,
  value = '',
  flowing = false,
  description,
  error,
  onChange,
  onBlur,
  required = false,
  placeholder,
  action,
  position,
  maxLength,
  ...rest
}: TooltipInputProps) => (
  <Tooltip
    trigger={(
      <Input
        id={id}
        key={name}
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        action={action}
        maxLength={maxLength}
        {...rest}
      />
        )}
    position={position}
    // @ts-expect-error
    flowing={flowing}
    description={description}
    {...(error && {
      message: error.message,
      type: 'error',
    })}
  />
);

export default TooltipInput;
